<script setup lang="ts">
import type { Tone } from '../lib/format.js';
/** A tone dot plus label. `pulse` is reserved for states that are changing right now. */
defineProps<{ tone: Tone; pulse?: boolean | undefined }>();
</script>

<template>
  <span class="pill" :data-tone="tone" :data-pulse="pulse ? 'true' : undefined">
    <i class="pill-dot" aria-hidden="true" /><slot />
  </span>
</template>
